import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo';
import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorSocial } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorSocial;
};
